import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  TextField,
  Button,
  MenuItem,
  Box,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { serviceOptions } from "../../data/ServiceSectionData";
import "./ContactForm.css";

export default function ContactForm({ title, subtitle, buttonText }) {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    location: "",
    googleMapsLink: "",
    service: "",
    otherService: "",
    message: "",
    file: null,
  });

  const [openToast, setOpenToast] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formDataEncoded = new FormData(form);

    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formDataEncoded).toString(),
      });

      setOpenToast(true);
      form.reset();
      setFormData({
        name: "",
        mobile: "",
        email: "",
        location: "",
        googleMapsLink: "",
        service: "",
        otherService: "",
        message: "",
        file: null,
      });
    } catch (error) {
      console.error("Form submission error", error);
    }
  };

  const handleCloseToast = (_, reason) => {
    if (reason === "clickaway") return;
    setOpenToast(false);
  };

  return (
    <Box>
      {title && (
        <Typography variant="h4" className="form-title">
          {title}
        </Typography>
      )}

      {subtitle && (
        <Typography variant="subtitle1" className="form-subtitle">
          {subtitle}
        </Typography>
      )}

      <form
        className="contact-form"
        name="contact"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        encType="multipart/form-data"
        onSubmit={handleSubmit}
      >
        {/* Netlify required hidden fields */}
        <input type="hidden" name="form-name" value="contact" />
        <input type="hidden" name="bot-field" />

        {/* Dynamic Email Subject for Netlify */}
        <input
          type="hidden"
          name="subject"
          value={`New Project Inquiry from ${
            formData.name || "Website Visitor"
          } – ${formData.service || "General Service"}`}
        />

        {/* Name & Mobile */}
        <div className="form-row">
          <TextField
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="Mobile"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
        </div>

        {/* Email & Location */}
        <div className="form-row">
          <TextField
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="Location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
        </div>

        {/* Google Maps Link */}
        <TextField
          label="Google Maps Link"
          name="googleMapsLink"
          value={formData.googleMapsLink}
          onChange={handleChange}
          variant="outlined"
          fullWidth
        />

        {/* Service */}
        <TextField
          select
          label="Service"
          name="service"
          value={formData.service}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          required
        >
          {serviceOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>

        {/* Other Service */}
        {formData.service === "Others" && (
          <TextField
            label="Specify Service"
            name="otherService"
            value={formData.otherService}
            onChange={handleChange}
            variant="outlined"
            fullWidth
          />
        )}

        {/* Message */}
        <TextField
          label="Your Project Ideas or Queries"
          name="message"
          value={formData.message}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          multiline
          rows={4}
        />

        {/* Submit */}
        <Button type="submit" variant="contained" className="submit-btn">
          {buttonText}
        </Button>
      </form>

      {/* SUCCESS TOASTER */}
      <Snackbar
        open={openToast}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseToast} severity="success" variant="filled">
          Thank you! We’ll contact you shortly.
        </Alert>
      </Snackbar>
    </Box>
  );
}

ContactForm.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
};

ContactForm.defaultProps = {
  title: "",
  subtitle: "",
  buttonText: "Submit",
};
